/**
 * @class SpotifyAuth
 */

import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import {Button, Typography} from '@mui/material';
import { UserContext } from './UserContext'
import { ReactComponent as SpotIcon } from '../assets/spot.svg';


const SpotifyContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const REDIRECT_URI = process.env.REACT_APP_SPOTIFY_REDIRECT_URI

class SpotifyLogin extends Component {
  static contextType = UserContext


  constructor(props) {
    super(props)
    this.state = {
      isAuthenticatedWithSpotify: false
    }
  }

  componentDidMount() {
    // Check cookies on component mount to reload login
    if(window.location.search.includes("?code=")){
      const accessToken = window.location.search.replace("?code=", "")
      if (accessToken) {
        if (!this.props.noCookie) {
          document.cookie = `spotifyAuthToken=${accessToken}; max-age=${60 * 60};`
        }
        if (this.props.localStorage) {
          window.localStorage.setItem('spotifyAuthToken', accessToken)
        }
        window.opener?.postMessage({ type: 'react-spotify-auth', accessToken }, '*')
        this.dallpaperSpotifyLogin(accessToken)
      }
    }
  }

  handleClick = (event) => {
    event.preventDefault()

    const scopes = ['user-top-read', 'user-read-recently-played', 'user-library-read', 'user-read-email']
    const spotifyRedirectUrl = 'https://accounts.spotify.com/authorize?response_type=code' +
      `&client_id=565b4293ff0c4108864c78ca59eb94fb` +
      `&scope=${scopes.join('%20')}` +
      `&redirect_uri=${REDIRECT_URI}` +
      '&show_dialog=false'

    if (window.location !== window.parent.location) {
      const loginWindow = window.open(spotifyRedirectUrl)
      window.addEventListener('message', (event) => {
        if (event.data.type !== 'react-spotify-auth' || !event.data.accessToken) {
          return
        }
        loginWindow.close()
        this.dallpaperSpotifyLogin(event.data.accessToken)
      }, false)
    } else {
      window.location = spotifyRedirectUrl
    }
  }

  dallpaperSpotifyLogin = async (authCode) => {
    const {user, setUser} = this.context
    if (user && !user.signed_into_spotify){
      const options  =  {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer: ' + user.firebase_token},
        body: JSON.stringify({ auth_code: authCode, redirect_uri: REDIRECT_URI})
      };
      try {
        const response = await fetch(`${process.env.REACT_APP_DALLPAPER_API_URL}/login/spotify`, options)
        const spotifyLoginResponse = await response.json()
        if (response.ok){
          console.log("Confirmed spotify token in database", spotifyLoginResponse)
          setUser({...user, signed_into_spotify: true})
        }
        else {
          console.log(">:( Failed to store spotify token in database", spotifyLoginResponse)
        }
      } catch (e) {
        console.log("Could not reach backend", e)
      }
    }
  }

  render() {
    return (
      <SpotifyContainer>
        <div>Link your account with Spotify?</div>
        <Button onClick={(event) => this.handleClick(event)}>
          <SpotIcon style={{width: "10%"}}></SpotIcon>
        </Button>
      </SpotifyContainer>
    )
  }
}

export default SpotifyLogin
